export default {
  CompositeList: ['试卷讲评', '考试巩固练'],
  examComment: {
    label1: '年级',
    label2: '考试时间',
    label3: '考试名称',
    labelTime1: '开始时间',
    labelTime2: '结束时间',
    placeholder: '请输入考试名称',
    btn1: '试卷讲评',
    checkClass: '请选择班级',
    checksub: '请选择学科',
    examination_type: [
      '练习考试',
      '周考试',
      '月考试',
      '期中考试',
      '期末考试',
      '模拟考试'
    ],
    gradeAll: '全部'
  },
  paperComments: {
    btn1: '导出',
    title1: '试卷概览',
    title2: '试题分析',
    label1: '排序方式',
    title3: '答题情况',
    titlt4: '题型分布',
    answerLabel: '答    案',
    answerno: '未设置答案',
    knowlabel: '知识点',
    knowno: '未设置知识点',
    analyLabel: '解    析',
    analyno: '未设置解析',
    stat: '答题统计',
    intervaltit: '调整分数区间',
    stuList: '学生答题名单',
    stuTip: '（点击作答选项，可查看学生留痕题卡）',
    notdata: '该考试下没有试题',
    modalLabel: '分数区间',
    modaltext: '分一段',
    modalTip1: '注：该题满分',
    modalTip2: '分',
    paperColor: ['容易', '较易', '一般', '较难', '困难'],
    columns: ['', '平均分', '最高分', '最低分'],
    sortList: ['按题号排序', '按班级得分率升序', '按班级得分率降序'],
    columnsType: ['题型名称', '题号', '数量', '占比'],
    columnsExam: [
      '班级',
      '平均分',
      '得分率',
      '最高分',
      '最低分',
      '失分人数',
      '失分占比',
      '总分'
    ],
    columnsAnswer: ['序号', '学生姓名', '得分', '得分率', '作答'],
    ti: '题',
    tableData: ['班级', '年级'],
    quschild: '小题',
    rangeScorePlach: '请输入数字',
    rangeScoreRules: '请输入分数区间',
    see: '查看',
    noImg: '没有答题卡图片',
    noImg2: '学生未上传图片',
    examNum: '题号',
    answerAll: ['', '年级'],
    seteSuccess: '分数区间设置成功',
    analysisChart: {
      formatter: '得分率',
      xAxisName: '题号',
      yAxisName: '得分率(%)'
    },
    downPdfTip: '下载中，请稍后...',

    downStudentScore: '下载学生成绩单',
    downStudentDetaial: '学生答题明细下载'
  },
  consolodata: {
    examTime: '考试日期',
    getquestion: '去获取题目信息',
    release: '发布巩固练',
    valiquestion: '验证题目',
    down: '下载',
    more: '更多',
    del: '删除',
    proModaltit: '下载考试巩固练习进度',
    protip: '正在加载，请勿进行其他操作，加载完成后，点击确定进行下载',
    pronum: '数据队列',
    downModaltit: '选择下载的班级',
    downoktext: '确定下载',
    downlabel1: '下载范围',
    downType1: '按班级下载',
    downType2: '按学生分组下载',
    checkAll: '全选',
    downlabel2: '下载格式',
    relaseModaltit: '考试巩固练发布',
    relaselabel1: '发布方式',
    publishType0: '分层发布',
    publishType1: '个性发布',
    relaselabel2: '分层方式',
    level1: '第一层次：年级前',
    level2: '第二层次：年级中',
    level3: '第三层次：年级后',
    levelrate: '推题难度：易、中、难比例为',
    relaselabel3: '个性方式',
    yi: '易',
    zhong: '中',
    nan: '难',
    relaselabel4: '试卷题量',
    byorinum0: '大概30分钟题量',
    byorinum1: '原考试试卷题量',
    relaselabel5: '发布试卷',
    tao: '套',
    class: '选择班级',
    againtit: '重新获取题目信息',
    againtip: '发布失败，需要重新校对信息！',
    againtip2: '联系运营人员',
    againBtn: '重新获取',
    columns: [
      '学科',
      '获取题目信息时间',
      '发布巩固练时间',
      '发布方式',
      '验证状态',
      '发布人',
      '任务管理'
    ],
    isChecked0: '未完成验证',
    isChecked1: '已完成验证',
    has_permissions: '您没有考试安排的权限，无法获取变式题，请联系管理员！',
    downSucess: '下载成功',
    seLockStatus: '请先发布成绩再发布巩固练',
    noClass: '获取到的班级为空',
    publishSuccess: '发布成功',
    downNum: ['个性化推送', '层级一', '层级二', '层级三'],
    eleMsg: '等待中...',
    noSelect: '没有选择班级或者组，请选择班级再下载',
    delTit: '重新获取信息',
    delTit1: '删除',
    delcontents:
      '确认删除后，需要重新获取考试题目信息后，才能再次发布巩固练，并且新生成的内容与这次不同。是否继续？',
    delcontents1:
      '确认删除后，再次发布巩固练时新生成的内容与这次不同，是否继续？',
    delsucess: '删除成功'
  }
}
